import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

import switzerland1 from '../images/switzerland1.jpeg';
import switzerland2 from '../images/switzerland2.jpeg';
import switzerland3 from '../images/switzerland3.jpeg';
import switzerland4 from '../images/switzerland4.jpeg';
import switzerland5 from '../images/switzerland5.jpeg';
import switzerland6 from '../images/switzerland6.jpeg';
import switzerland7 from '../images/switzerland7.jpeg';
import switzerland8 from '../images/switzerland8.jpeg';
import switzerland9 from '../images/switzerland9.jpeg';
import switzerland10 from '../images/switzerland10.jpeg';
import switzerland11 from '../images/switzerland11.jpeg';
import switzerland12 from '../images/switzerland12.jpeg';
import switzerland13 from '../images/switzerland13.jpeg';
import switzerland14 from '../images/switzerland14.jpeg';
import switzerland15 from '../images/switzerland15.jpeg';
import switzerland16 from '../images/switzerland16.jpeg';
import switzerland17 from '../images/switzerland17.jpeg';
import switzerland18 from '../images/switzerland18.jpeg';
import switzerland19 from '../images/switzerland19.jpeg';
import switzerland20 from '../images/switzerland20.jpeg';
import switzerland21 from '../images/switzerland21.jpeg';
import switzerland22 from '../images/switzerland22.jpeg';
import switzerland23 from '../images/switzerland23.jpeg';
import switzerland24 from '../images/switzerland24.jpeg';
import switzerland25 from '../images/switzerland25.jpeg';
import switzerland26 from '../images/switzerland26.jpeg';
import switzerland27 from '../images/switzerland27.jpeg';
import switzerland28 from '../images/switzerland28.jpeg';
import switzerland29 from '../images/switzerland29.jpeg';
import switzerland30 from '../images/switzerland30.jpeg';
import switzerland31 from '../images/switzerland31.jpeg';
import switzerland32 from '../images/switzerland32.jpeg';
import switzerland33 from '../images/switzerland33.jpeg';
import switzerland34 from '../images/switzerland34.jpeg';
import switzerland35 from '../images/switzerland35.jpeg';
import switzerland36 from '../images/switzerland36.jpeg';
import switzerland37 from '../images/switzerland37.jpeg';
import switzerland38 from '../images/switzerland38.jpeg';
import switzerland39 from '../images/switzerland39.jpeg';
import switzerland40 from '../images/switzerland40.jpeg';
import switzerland41 from '../images/switzerland41.jpeg';
import switzerland42 from '../images/switzerland42.jpeg';
import switzerland43 from '../images/switzerland43.jpeg';

function Switzerland() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images - switzerland1-43
  const photos = [
    switzerland1, switzerland2, switzerland3, switzerland4, switzerland5, switzerland6, switzerland7, switzerland8, switzerland9, switzerland10,
    switzerland11, switzerland12, switzerland13, switzerland14, switzerland15, switzerland16, switzerland17, switzerland18, switzerland19, switzerland20,
    switzerland21, switzerland22, switzerland23, switzerland24, switzerland25, switzerland26, switzerland27, switzerland28, switzerland29, switzerland30,
    switzerland31, switzerland32, switzerland33, switzerland34, switzerland35, switzerland36, switzerland37, switzerland38, switzerland39, switzerland40,
    switzerland41, switzerland42, switzerland43
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇨🇭 Switzerland 2025 🇨🇭</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Switzerland ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Switzerland;